import { getCurrentHub } from '@sentry/nextjs'
import { InternalAxiosRequestConfig } from 'axios'
import { SENTRY_TRACE_HEADER, VERCEL_REQ_ID_HEADER } from 'constants/common'

export const forwardTracingHeaders = <
  TConfig extends InternalAxiosRequestConfig,
>(
  config: TConfig
): TConfig => {
  // when axios client is used within API route,
  // forward `sentry-trace` and `x-vercel-id`
  // headers if Sentry transaction exists
  if (typeof window === 'undefined') {
    const transaction = getCurrentHub()?.getScope()?.getTransaction()

    if (transaction && config.headers) {
      const { headers } = config

      headers[
        SENTRY_TRACE_HEADER
      ] = `${transaction.traceId}-${transaction.spanId}`

      if (transaction.data[VERCEL_REQ_ID_HEADER]) {
        headers[VERCEL_REQ_ID_HEADER] = transaction.data[VERCEL_REQ_ID_HEADER]
      }
    }
  }
  return config
}
